import { Trans } from '@lingui/macro'
import React from 'react'
import { Route } from 'react-router-dom'
import { Row } from 'reactstrap'
import styled from 'styled-components/macro'

import { ColStyle } from '../../common/ColStyle'
import { LanguagePicker } from '../../common/LanguagePicker'
import {
  QShopHeaderBranchBranch,
  QShopHeaderIntroIntro,
} from '../../graph/generated'
import { OrderAddress } from './OrderAddress'
import { ShopCloseAlert } from './ShopCloseAlert'
import { ShopClosingTimeModal } from './ShopClosingTimeModal'
import { ShopHeaderIcons } from './ShopHeaderIcons'
import { ShopIntro } from './ShopIntro'
import { ShopLogo } from './ShopLogo'
import { ShopOpeningHours } from './ShopOpeningHours'
import { Sticker } from './Sticker'

type TProps = {
  branch: QShopHeaderBranchBranch | null
  intro: QShopHeaderIntroIntro | null
  highlightSpeedlo: boolean
}

const StyledShopHeader = styled.div`
  display: flex;
  min-height: 200px;
  & div.info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`

const StyledLanguagePicker = styled(LanguagePicker)`
  position: absolute;
  z-index: 1;
  right: 1rem;
  top: 2.5rem;

  .wrapper {
    height: 1.2rem;
  }
`

export const ShopHeader: React.FC<TProps> = ({
  branch,
  intro,
  highlightSpeedlo,
}) => (
  <div>
    <Row className="justify-content-md-center">
      <ColStyle>
        <ShopHeaderIcons bigLogo={highlightSpeedlo} />
        <StyledLanguagePicker />
      </ColStyle>
      {branch && <ShopCloseAlert status={branch} />}
    </Row>

    <Row className="row-white justify-content-md-center">
      <ColStyle>
        <StyledShopHeader data-testid="shopHeader">
          <>
            <ShopLogo
              smallLogo={highlightSpeedlo}
              url={intro ? intro.homepageUrl : null}
            />

            <div className="info">
              <Route
                exact={true}
                path="/"
                render={() => (
                  <>
                    <Sticker>
                      <Trans>Choose your delivery option below</Trans>
                    </Sticker>
                    <ShopIntro intro={intro} />
                  </>
                )}
              />
              <Route
                path="/order"
                render={() => (
                  <>
                    {branch && <ShopClosingTimeModal status={branch} />}
                    <Sticker success={true}>
                      <OrderAddress address={branch ? branch.address : null} />
                    </Sticker>
                    <ShopOpeningHours branch={branch} />

                    <ShopIntro intro={intro} />
                  </>
                )}
              />
              <Route
                path="/finish"
                render={() => (
                  <>
                    <Sticker success={true}>
                      <Trans>Order was send</Trans>
                    </Sticker>
                    <ShopOpeningHours branch={branch} />
                    <ShopIntro intro={intro} />
                  </>
                )}
              />
            </div>
          </>
        </StyledShopHeader>
      </ColStyle>
    </Row>
  </div>
)
